export enum ELoaiTaiKhoan {
  AdminTong = 0,
  ThongThuong = 1,
}

export enum EGioiTinh {
  Nam = 1,
  Nu = 2,
  Khac = 3,
}

export enum ETinhTrangHonNhan {
  DocThan = 0,
  DaKetHonChuaCon = 1,
  DaKetHonMotCon = 2,
  DaKetHonHaiCon = 3,
}

export enum ELoaiHinhNhanVien {
  ThucTap = 1,
  CTV = 2,
  ThuViec = 3,
  ChinhThuc = 4,
}

export enum ETrangThaiNhanVien {
  DaNghiViec = 0,
  DangLamViec = 1,
  HoanLamViec = 2,
}

export enum ELoaiKhenThuongKyLuat {
  KyLuat = 0,
  KhenThuong = 1,
}
export enum ELoaiHopDong {
  HopDongHopTac = 1,
  HopDongLaoDong = 2,
}

export enum EBucketName {
  PUBLIC = 'public',
  PRIVATE = 'private',
}
